import WeatherGlyph from './WeatherGlyph';
import { labelFor, rainWorthSaying, type Hour } from '../lib/weather';
import { fmtTime } from '../lib/time';

/**
 * Hours as a horizontal strip you scroll sideways (D67).
 *
 * Shared by the Schedule's per-day strip on a phone and by the pill's panel on
 * Now, so the two cannot drift. It carries one decision that is easy to get
 * right in only one place: the rain figure is printed only past
 * `RAIN_THRESHOLD`, and a dry hour renders the slot empty rather than printing
 * a placeholder — the height is held in CSS, so the row of temperatures stays
 * level across a day where only some hours are wet.
 *
 * Scrolls rather than wrapping. A wrapped strip reads as a second day, and the
 * cells are a sequence: twelve of them at 40px is 480px of content in a 358px
 * column.
 */
export default function WeatherHourStrip({ hours, label }: { hours: Hour[]; label: string }) {
  return (
    <div className="wx-hours-row" role="group" aria-label={label}>
      {hours.map((hour) => (
        <div className="wx-hour" key={hour.at}>
          <span className="wx-hour-at">{fmtTime(hour.at)}</span>
          {/* The glyph is `aria-hidden` inside `Icon`, so the condition has to
              reach a screen reader as text or it does not reach it at all. */}
          <span className="wx-hour-glyph">
            <WeatherGlyph code={hour.code} isDay={hour.isDay} size={17} />
            <span className="sr-only">{labelFor(hour.code)}</span>
          </span>
          <span className="wx-hour-temp">{hour.temp}°</span>
          <span className="wx-hour-rain">
            {rainWorthSaying(hour) ? `${hour.rainChance}%` : ''}
          </span>
        </div>
      ))}
    </div>
  );
}
